'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { DOCS_PAGES_FLAT } from './nav';

/** Previous / next pager derived from the flat docs page order. */
export default function PageNav() {
  const pathname = usePathname();
  const index = DOCS_PAGES_FLAT.findIndex((p) => p.href === pathname);
  if (index === -1) return null;

  const prev = index > 0 ? DOCS_PAGES_FLAT[index - 1] : null;
  const next = index < DOCS_PAGES_FLAT.length - 1 ? DOCS_PAGES_FLAT[index + 1] : null;

  return (
    <nav className="mt-16 grid grid-cols-1 gap-4 border-t border-neutral-800/60 pt-8 sm:grid-cols-2">
      {prev ? (
        <Link
          href={prev.href}
          className="group flex flex-col border border-neutral-800/70 bg-neutral-950/40 p-4 transition-colors hover:border-rose-500/30"
        >
          <span className="flex items-center gap-1.5 text-xs text-neutral-500">
            <ArrowLeft className="h-3.5 w-3.5" /> Previous
          </span>
          <span className="mt-1 text-sm font-medium text-white group-hover:text-rose-400">{prev.title}</span>
        </Link>
      ) : (
        <span />
      )}
      {next && (
        <Link
          href={next.href}
          className="group flex flex-col items-end border border-neutral-800/70 bg-neutral-950/40 p-4 text-right transition-colors hover:border-rose-500/30"
        >
          <span className="flex items-center gap-1.5 text-xs text-neutral-500">
            Next <ArrowRight className="h-3.5 w-3.5" />
          </span>
          <span className="mt-1 text-sm font-medium text-white group-hover:text-rose-400">{next.title}</span>
        </Link>
      )}
    </nav>
  );
}
